import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useGuestAuth } from '@/lib/contexts/guest-auth-context';

/**
 * Guard pour les routes qui nécessitent une authentification guest (OTP validé).
 * Attend la vérification de session avant de rediriger.
 */
export function RequireGuestAuth({ children }: { children: React.ReactNode }) {
    const { isAuthenticated, isCheckingSession, invitationUuid } = useGuestAuth();
    const location = useLocation();

    // Attendre la fin de la vérification de session (cookie HTTP-only)
    if (isCheckingSession) {
        return (
            <div className="bg-surface min-h-[calc(100vh-7rem)] flex items-center justify-center">
                <div className="flex flex-col items-center gap-4">
                    <Loader2 className="h-8 w-8 animate-spin text-secondary" />
                    <p className="text-[14px] text-muted-foreground">Vérification de la session...</p>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to={`/public/invite/${invitationUuid}`} state={{ from: location }} replace />;
    }

    return <>{children}</>;
}
